/**
 * Asynchronously update the cart using ther shopify AJAX API.
 * ref: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-update-js
 *
 * @param {object} updates - The ID of the product to add to the cart.
 * @return {Promise} A promise that resolves when the product has been added to the cart.
 * @throws {Error} If the product ID is missing or if there is an error adding the product to the cart.
 *
 * expected usage:
 *
 * where keys is the line item's variant_id
 * const payload = {
 *   updates: {
 *     key1: value1,
 *     key2: value2
 *   }
 * }
 * const newCart = await updateCart(payload);
 */
export const updateCart = async (updates) => {
  if (!updates) {
    console.warn('missing updates to change the cart.')
    return
  }
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updates),
    })

    if (!response.ok) {
      console.error('bad request: ', response)
      return null
    }

    return response.json()
  } catch (err) {
    console.error('Error updating the cart. updates: ', updates, ' error: ', err)
    throw new Error(err);
  }
}